import axios from 'axios';
import React, { useEffect, useState } from 'react';

export default function TireWidth({ localizedData, widthValue, setwidthValue, type }) {
  const [sizes, setSizes] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSizes = async (controller) => {
    setLoading(true);
    const { data } = await axios.get('/wp-json/stm/v1/lookup/tire/width', {
      signal: controller.signal,
      params: {
        type,
      },
    });
    setSizes(data);
    setLoading(false);
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchSizes(controller);
    return () => {
      controller.abort();
    };
  }, [type]);

  return (
    <div className="w-full">
      <label htmlFor="tireWidth" className="sr-only">
        {localizedData.optionsFields.tire_width}
      </label>
      <input
        type="text"
        list="tireWidthOptions"
        className="text-small border-dark-gray mb-4 w-full border px-2 py-1 text-black"
        id="tireWidth"
        name="Tire Width"
        value={widthValue}
        disabled={loading}
        placeholder={loading ? localizedData.optionsFields.loading : localizedData.optionsFields.tire_width}
        aria-label={localizedData.optionsFields.tire_width}
        onChange={(e) => setwidthValue(e.target.value)}
      />
      <datalist id="tireWidthOptions">
        {sizes && sizes.map((size) => (
          <option value={size} key={size} />
        ))}
      </datalist>
    </div>
  );
}
